import {
  IQuickVideo,
  IQuickVideoPartPositionOption,
  IQuickVideoPartTestSendForm,
  IQuickVideoTestSendForm,
} from 'lib/api/quickVideo/types';
import { ICombinedUserData } from 'lib/context';

export const getQuickVideoTestSendInitialValues = ({
  userData,
  quickVideo,
  positions,
}: {
  userData: ICombinedUserData;
  quickVideo: IQuickVideo;
  positions: IQuickVideoPartPositionOption[];
}) => {
  const quickVideoParts: IQuickVideoPartTestSendForm[] = positions.map(vpd => ({
    partPosition: vpd.value,
    partType: '',
    video: null,
    quickVideoPartId: 0,
    description: '',
  }));

  quickVideoParts.forEach((part, index) => {
    const matchingProvidedPart = (quickVideo.quickVideoParts || []).find(
      p => p.partPosition === part.partPosition
    );
    if (!!matchingProvidedPart) {
      quickVideoParts[index] = {
        quickVideoPartId: matchingProvidedPart.quickVideoPartId,
        partPosition: matchingProvidedPart.partPosition,
        partType: matchingProvidedPart.partType,
        description: matchingProvidedPart.description || '',
        video:
          matchingProvidedPart?.quickVideoPartCustomerConfiguration?.video ||
          null,
      };
    }
  });

  return {
    recipientEmail: `${userData.email}           ${userData.phone1}` || '',
    recipientName: '',
    inventoryItemId: 0,
    quickVideoParts,
  } satisfies IQuickVideoTestSendForm;
};
